/**
 * c-header.js — hamburger_menu レイアウト用メニュー開閉制御
 */

class CHeaderMenuPanel extends HTMLElement {
  connectedCallback() {
    // position: fixed の containing block 問題を回避するため body 直下に移動
    // appendChild で再度 connectedCallback が発火するため、初期化済みガードを設ける
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
      return; // 移動後に再度 connectedCallback が呼ばれるのでここでは初期化しない
    }

    if (this._initialized) return;
    this._initialized = true;

    this.toggleBtn = document.querySelector('[aria-controls="c-header-menu-panel"]');
    this.overlay = this.querySelector('.c-header-menu-panel__overlay');
    this.headerEl = document.querySelector('.header');

    // ヘッダーセクションの z-index をパネルより高くする（パネルが body 直下のため）
    // 注: position は上書きしない（sticky/relative はテーマCSSで管理）
    //      z-index のみ設定し、position: sticky のスタッキングコンテキストを活用する
    const headerSection = document.querySelector('.shopify-section--header');
    if (headerSection) {
      headerSection.style.zIndex = '11';
    }

    // 検索パネルの参照を取得
    this.searchEl = document.querySelector('header-search');

    if (this.toggleBtn) {
      this.toggleBtn.addEventListener('click', () => this.toggle());
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.hasAttribute('open')) {
        this.close();
      }
    });

    // 検索アイコンがクリックされたらドロワーを閉じる
    const searchTrigger = document.querySelector('[aria-controls^="header-search-"]');
    if (searchTrigger) {
      searchTrigger.addEventListener('click', () => {
        if (this.hasAttribute('open')) {
          this.close();
        }
      });
    }
  }

  open() {
    // announcement bar が見えている場合、ヘッダーを viewport top に吸着させる
    // （パネルは fixed; inset:0 のため、ヘッダーとの隙間にコンテンツが漏れるのを防ぐ）
    const announcementBar = document.querySelector('.shopify-section--announcement-bar');
    if (announcementBar) {
      const abRect = announcementBar.getBoundingClientRect();
      if (abRect.bottom > 0) {
        window.scrollTo({ top: window.scrollY + abRect.bottom, behavior: 'instant' });
      }
    }

    // 検索パネルが開いていたら閉じる
    if (this.searchEl && this.searchEl.hasAttribute('open')) {
      this.searchEl.removeAttribute('open');
    }

    this.setAttribute('open', '');
    this.setAttribute('aria-hidden', 'false');
    if (this.toggleBtn) {
      this.toggleBtn.setAttribute('aria-expanded', 'true');
    }
    document.body.style.overflow = 'hidden';
    if (this.headerEl) {
      this.headerEl.classList.add('c-header--menu-open');
    }
  }

  close() {
    this.classList.add('is-closing');

    const onEnd = () => {
      this.classList.remove('is-closing');
      this.removeAttribute('open');
      this.setAttribute('aria-hidden', 'true');
      if (this.toggleBtn) {
        this.toggleBtn.setAttribute('aria-expanded', 'false');
      }
      document.body.style.overflow = '';
      if (this.headerEl) {
        this.headerEl.classList.remove('c-header--menu-open');
      }
    };

    const inner = this.querySelector('.c-header-menu-panel__inner');
    if (inner) {
      inner.addEventListener('transitionend', onEnd, { once: true });
      // フォールバック: transitionend が発火しない場合
      setTimeout(onEnd, 400);
    } else {
      onEnd();
    }
  }

  toggle() {
    this.hasAttribute('open') ? this.close() : this.open();
  }
}

if (!customElements.get('c-header-menu-panel')) {
  customElements.define('c-header-menu-panel', CHeaderMenuPanel);
}
